<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8"/>
  <title>AVEnGeRS (Confidential)</title>
</head>
<body>
<div id="root"></div>
<script type="module" src="index.ts"></script>
</body>
</html>
